<template>
  <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
    <v-row class="no-gutters">
      <v-col cols="12" sm="6" md="6" lg="3">
        <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search here ..." single-line solo
          hide-details></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="2">
        <v-select solo :items="allAccounts()" v-model="account" @input="accountFilter" append-icon="mdi-chevron-down"
          label="All Accounts" class="custom-select"></v-select>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-dialog ref="dialog" v-model="modal" :return-value.sync="dates" width="290px" class="">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="dateRangeText" prepend-icon="mdi-calendar" append-icon="mdi-chevron-down" readonly
              v-bind="attrs" v-on="on" solo class="custom-select"></v-text-field>
          </template>
          <v-date-picker v-model="dates" @input="dateFilter" class="custom-date-picker" scrollable range>
            <v-spacer></v-spacer>
            <v-btn :color="$vuetify.theme.dark ? '#ff567f' : '#ff567f'" text @click="cancelAction">
              Cancel
            </v-btn>
            <v-btn :color="$vuetify.theme.dark ? '#fff' : '#131c29'" text @click="$refs.dialog.save(date)">
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="4">
        <ul>
          <li>
            <span>Total Equity:</span>
            <span>{{ accountSummary?.liveTrades?.equity?.toFixed(2) }}</span>
          </li>
          <li>
            <span>Total Lot:</span>
            <span>{{accountSummary?.liveTrades?.totalLot?.toFixed(2) }}</span>
          </li>
          <li>
            <span class="profit-loss">Profit / Loss:</span>
            <span>{{accountSummary?.liveTrades?.profitLoss?.toFixed(2) }}</span>
          </li>
        </ul>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12">
        <v-card class="pa-3 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
          <v-sheet class="transactionTable liveTradeTable pb-3" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
            <v-data-table :headers="headers" :items="filteredData" :search="search" :items-per-page="6">
              <template v-slot:item.serial="{ item, index }">
                <span>
                  {{ index + 1 }}
                </span>
              </template>
              <template v-slot:item.TimeCreate="{ item }">
                <span>
                  {{ formatMySQLDate(item?.TimeCreate)}}
                </span>
              </template>
              <template v-slot:item.PriceSL="{ item }">
                <span class="profit-text-color">
                  {{ item?.PriceSL }} - {{ item?.PriceTP }}
                </span>
              </template>
              <template v-slot:item.Volume="{ item }">
                <span class="profit-text-color">
                  {{ item?.Volume / 10000 }}
                </span>
              </template>
              <template v-slot:item.PriceOpen="{ item }">
                <span class="profit-text-color">
                  {{ item?.PriceOpen?.toFixed(5) }}
                </span>
              </template>
              <template v-slot:item.PriceCurrent="{ item }">
                <span class="profit-text-color">
                  {{ item?.PriceCurrent?.toFixed(5) }}
                </span>
              </template>
              <template v-slot:item.detail="{ item }">
                <router-link class="links text-decoration-none" to="/">
                  <v-icon small>
                    {{ item?.detail }}
                  </v-icon>
                </router-link>
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" xl="12">
        <MiddleBar></MiddleBar>
      </v-col>
    </v-row>
    <LiveAccounts></LiveAccounts>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TRADING__ACTIONS } from "@/store/action-types";

import LiveAccounts from "./LiveAccounts.vue";
import MiddleBar from "./MiddleBar.vue";

export default {
  components: { MiddleBar, LiveAccounts },
  data() {
    return {
      headers: [
        { text: "Sl", value: "serial", align: "start" },
        {
          text: "Date & Time",
          align: "start",
          value: "TimeCreate",
        },
        { text: "Acc. No.", value: "trading_account_no" },
        { text: "Ticket", value: "Position" },
        {
          text: "Acc. Type",
          value: "tradingaccounttypes.account_type_display",
        },
        { text: "Lots", value: "Volume" },
        { text: "Symbol", value: "Symbol" },
        { text: "Open Price($)", value: "PriceOpen" },
        { text: "SL-TP", value: "PriceSL" },
        { text: "Running($)", value: "PriceCurrent" },
        { text: "Equity($)", value: "Equity" },
        { text: "Profit($)", value: "Profit" },
      ],
      modal: false,
      search: "",
      account: "",
      dates: [],
      filteredData: [],
    };
  },
  computed: {
    ...mapState("trading", ["allLiveTrades", "accountSummary"]),
    dateRangeText() {
      return ["2022-01-01", this.getCurrentDate()].join(" ~ ");
    },
  },
  methods: {
    formatMySQLDate(mysqlDate) {
    

    // Ensure the input is in the correct format
    if (!mysqlDate) return "Invalid date";

    // Replace the "T" with a space to work with the current logic
    const isoFormattedDate = mysqlDate.replace('T', ' ').split('.')[0]; // Removes milliseconds
    const [datePart, timePart] = isoFormattedDate.split(' ');
    const [year, month, day] = datePart.split('-');
    const [hour, minute] = timePart.split(':');

    // Convert 24-hour time to 12-hour time
    const hour12 = hour % 12 || 12;
    const amPm = hour >= 12 ? 'pm' : 'am';

    // Return the formatted date and time
    return `${day}.${month}.${year} - ${hour12}:${minute} ${amPm}`;
},
    getCurrentDate() {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      return formattedDate;
    },
    ...mapActions("trading", [TRADING__ACTIONS.ALLTRADEDETAILS]),

    allAccounts() {
      const accountNumbers = this.allLiveTrades.map(
        (acc) => acc.trading_account_no
      );
      return ["All", ...accountNumbers];
    },

    dateFilter() {
      if (this.dates.length === 2) {
        let startDate = new Date(this.dates[0]);
        let endDate = new Date(this.dates[1]);

        // Swap dates if startDate is smaller than endDate
        if (startDate > endDate) {
          [startDate, endDate] = [endDate, startDate];
        }

        // Increment the endDate by one day
        endDate.setDate(endDate.getDate() + 1);

        this.filteredData = this.allLiveTrades.filter((item) => {
          const tradeDate = new Date(item.TimeCreate.split(" ")[0]);
          return tradeDate >= startDate && tradeDate <= endDate;
        });
      } else {
        this.filteredData = this.allLiveTrades;
      }
    },

    accountFilter() {
      if (this.account === "All")
        return (this.filteredData = this.allLiveTrades);
      this.filteredData = this.allLiveTrades.filter(
        (item) => item.trading_account_no.toString() === this.account.toString()
      );
    },

    resetAll() {
      this.search = "";
      this.account = "";
      this.dates = [];
      this.filteredData = this.allLiveTrades;
    },

    cancelAction() {
      this.modal = false;
      this.resetAll();
    },
  },
  async mounted() {
    await this[TRADING__ACTIONS.ALLTRADEDETAILS]();
    this.filteredData = this.allLiveTrades;
  },
};
</script>
